/**
 * AI 生文左侧导航
 * @returns
 */
import {
  Box,
  Button,
  Flex,
  Icon,
  IconButton,
  Tooltip,
  Text,
  useDisclosure,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Image,
  Center,
  VStack,
  useToast,
} from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import navIcon11 from "@/assets/images/swsy.png";
import navIcon12 from "@/assets/images/swsy_h.png";
import navIcon21 from "@/assets/images/swxj.png";
import navIcon22 from "@/assets/images/swxj_h.png";
import navIcon31 from "@/assets/images/swfl.png";
import navIcon32 from "@/assets/images/swfl_h.png";
import navIcon41 from "@/assets/images/swls.png";
import navIcon42 from "@/assets/images/swls_h.png";
import {
  RiMessage2Line,
  RiSearchLine,
  RiBookOpenLine,
  RiMessage3Line,
  RiEdit2Line,
  RiDeleteBinLine,
  RiInboxLine,
} from "@remixicon/react";
import { useEffect, useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import MeetingListItem from "./meetingListItem";
import CreateChatModal from "./createChatModal";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { selectUser } from "@/reducer/userslice";
import {
  selectChatRoomList,
  selectKnowledgeBaseTopicList,
} from "@/reducer/chatSlice";
import { getChats } from "@/services/api/thunks/chat";
import KnowledgeListItem from "./knowledgeListItem";

const WritingLeft = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const currentUrl = location.pathname;
  const createControl = useDisclosure();
  const toast = useToast();
  const user = useAppSelector(selectUser);
  const chatRoomList = useAppSelector(selectChatRoomList);
  const knowledgeBaseTopicList = useAppSelector(selectKnowledgeBaseTopicList);
  const myknowledgeBaseTopicList = knowledgeBaseTopicList.filter(
    (item) => item.isPublic==="私有"
  );
  const publicknowledgeBaseTopicList = knowledgeBaseTopicList.filter(
    (item) => item.isPublic==="公开"
  );
  const [currentNavIndex, setCurrentNavIndex] = useState(0);
  const [isLeftSideOpen, setIsLeftSideOpen] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(getChats(user.id));
    };
    if (user && user.id) {
      fetchData();
    }
  }, []);
  const handleLeftSide = () => {
    setIsLeftSideOpen(!isLeftSideOpen);
  };

  const handleCreateNewChat = () => {
    if (user && user.id) {
      createControl.onOpen();
    } else {
      toast({
        title: "请登录系统",
        position: "top",
        status: "error",
        duration: 1000,
      });
    }
  };

  return (
    <Flex h="100%">
      <Flex
        w="48px"
        h="100%"
        pt="10px"
        borderRight={"1px solid #efeff5"}
        flexDirection={"column"}
        gap="10px"
        zIndex={10}
        position="relative"
        bgColor={"#fff"}
        pl="8px"
      >
        {/* 聊天 */}
        <Tooltip label="聊天" placement="right">
          <IconButton
            w="32px"
            minW={"32px"}
            h="32px"
            aria-label="聊天"
            variant={"unstyle"}
            color={currentUrl === "/ai/writing" ? "#496AE1" : "#27314D"}
            icon={<RiMessage2Line size={"22px"} />}
            bg={currentUrl === "/ai/writing" ? "#EDF2F7" : "none"}
            _hover={{
              bg: "#EDF2F7",
              color: "#496AE1",
            }}
            onClick={() => {
              navigate("/ai/writing");
            }}
          />
        </Tooltip>
        {/* <Tooltip label="知识库" placement="right">
          <IconButton
            w="32px"
            minW={"32px"}
            h="32px"
            aria-label="知识库"
            variant={"unstyle"}
            color={
              currentUrl === "/ai/writing/knowledgebase" ? "#496AE1" : "#27314D"
            }
            icon={<RiBookOpenLine size={"22px"} />}
            bg={currentUrl === "/ai/writing/knowledgebase" ? "#EDF2F7" : "none"}
            _hover={{
              bg: "#EDF2F7",
              color: "#496AE1",
            }}
            onClick={() => {
              navigate("/ai/writing/knowledgebase");
            }}
          />
        </Tooltip> */}
        {/* <Tooltip label="搜索" placement="right">
          <IconButton
            w="32px"
            minW={"32px"}
            h="32px"
            aria-label="搜索"
            variant={"unstyle"}
            color={
              currentUrl === "/ai/writing/aisearch" ? "#496AE1" : "#27314D"
            }
            icon={<RiSearchLine size={"22px"} />}
            bg={currentUrl === "/ai/writing/aisearch" ? "#EDF2F7" : "none"}
            _hover={{
              bg: "#EDF2F7",
              color: "#496AE1",
            }}
            onClick={() => {
              navigate("/ai/writing/aisearch");
            }}
          />
        </Tooltip> */}
      </Flex>
      {(currentUrl === "/ai/writing" ||
        currentUrl === "/ai/writing/knowledgebase") && (
        <Box
          h="100%"
          w={isLeftSideOpen ? "260px" : "0"}
          borderRight={"1px solid #efeff5"}
          transition="width 0.1s ease-out"
          position={"relative"}
          zIndex={9}
          bg="#fff"
        >
          {/* 聊天左侧 */}
          {isLeftSideOpen && currentUrl === "/ai/writing" && (
            <Box p="15px" boxSizing="border-box">
              <Button
                w="100%"
                h="34px"
                variant={"unstyle"}
                border={"1px dashed #e0e0e6"}
                color="#27314D"
                fontSize={"14px"}
                borderRadius="4px"
                fontWeight="normal"
                _hover={{
                  color: "#496AE1",
                  borderColor: "#496AE1",
                }}
                onClick={handleCreateNewChat}
              >
                新建聊天
              </Button>
              {chatRoomList && chatRoomList.length>0 && chatRoomList.map((item) => (
                <Box key={item.id}>
                  <MeetingListItem chatRoomInfo={item} />
                </Box>
              ))}
            </Box>
          )}

          {/* 知识库左侧 */}
          {isLeftSideOpen && currentUrl === "/ai/writing/knowledgebase" && (
            <Flex h="100%" boxSizing="border-box" flexDir={"column"}>
              {/* <Box></Box> */}
              <Tabs flex={1}>
                <TabList justifyContent={"space-around"}>
                  <Tab fontSize={"14px"}>我的</Tab>
                  <Tab fontSize={"14px"}>公开</Tab>
                </TabList>

                <TabPanels>
                  <TabPanel>
                    {myknowledgeBaseTopicList.length>0 &&
                      myknowledgeBaseTopicList.map((item) => (
                        <Box key={item.id}>
                          <KnowledgeListItem chatRoomInfo={item} />
                        </Box>
                      ))}
                    {myknowledgeBaseTopicList.length===0 && (
                      <VStack color="#d4d4d4" fontSize={"14px"} mt="10px">
                        <RiInboxLine size={"30px"} />
                        <Text>暂无数据</Text>
                      </VStack>
                    )}
                  </TabPanel>
                  <TabPanel>
                    {publicknowledgeBaseTopicList.length>0 &&
                      publicknowledgeBaseTopicList.map((item) => (
                        <Box key={item.id}>
                          <KnowledgeListItem chatRoomInfo={item} />
                        </Box>
                      ))}
                    {publicknowledgeBaseTopicList.length===0 && (
                      <VStack color="#d4d4d4" fontSize={"14px"} mt="10px">
                        <RiInboxLine size={"30px"} />
                        <Text>暂无数据</Text>
                      </VStack>
                    )}
                  </TabPanel>
                </TabPanels>
              </Tabs>
              <Box p="15px" boxSizing="border-box">
                <Button
                  w="100%"
                  h="34px"
                  variant={"unstyle"}
                  border={"1px dashed #e0e0e6"}
                  color="#27314D"
                  fontSize={"14px"}
                  borderRadius="4px"
                  fontWeight="normal"
                  _hover={{
                    color: "#496AE1",
                    borderColor: "#496AE1",
                  }}
                  onClick={() => {
                    navigate("/ai/writing/knowledgebase-set");
                  }}
                >
                  管理我的知识库
                </Button>
              </Box>
            </Flex>
          )}

          <IconButton
            minW="24px"
            w="24px"
            h="24px"
            variant={"unstyle"}
            position={"absolute"}
            top="50%"
            left={"100%"}
            transform="translate(-50% , -50%)"
            color={"#8E94A9"}
            bg="#fff"
            border="1px solid #efeff5"
            borderRadius={"24px"}
            aria-label="收起/展开"
            fontWeight={"bold"}
            icon={
              isLeftSideOpen ? (
                <ChevronLeftIcon boxSize={"20px"} />
              ) : (
                <ChevronRightIcon boxSize={"20px"} />
              )
            }
            onClick={handleLeftSide}
          />
        </Box>
      )}

      <CreateChatModal
        isOpen={createControl.isOpen}
        onClose={createControl.onClose}
      />
    </Flex>
  );
};

export default WritingLeft;
